import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { clearStateHistoryAction } from '../../../utilities/stateHistory/stateHistorySlice';
import TextInput from '../../../Components/Shared/TextInput/TextInput';
import BtnSubmit from '../../../Components/Shared/Buttons/BtnSubmit';
import Property from '@episerver/spa-core/Components/Property';
import moment from 'moment';
import Image from 'app/Components/Shared/Image/image';
//store functions
import { initBlock, resetBlock, clearResult, getWarrantyStatus, reportDWH } from './ManufacturerWarrantyStatusSlice';


const ManufacturerWarrantyStatus = (props) => {
    const [serialNumber, setSerialNumber] = useState("");
    const [validationError, setValidationError] = useState("");

    const formId = "manufacturer-warranty-status-form";

    //--------------- useEffect ---------------
    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            props.initBlock({ manufacturerWarrantyStatusBlockData: props.iContent });
            props.reportDWH({ actionType: 'WarrantyCheckPage', status: 'Ongoing', messageText: 'WarrantyCheckPageDisplayed' });

        }
        return () => {
            if (runSideEffects()) {
                props.resetBlock();
            }
        };
    }, []);

    useClearStateResetFlag();

    function onClickBtn() {
        let imei = serialNumber?.trim();
        if (imei == '') {
            setValidationError('אנא הכנס ערך');
            return;
        }
        setValidationError('');
        props.reportDWH({ actionType: 'WarrantyCheckPage', status: 'Ongoing', messageText: 'WarrantyCheckButtonClicked', IMEI: imei });
        props.getWarrantyStatus({ serialNumber: imei });
    }

    function onChangeInput(value) {
        setValidationError('');
        setSerialNumber(value);
    }

    function clearResultBtn() {
        setSerialNumber('');
        props.clearResult();

    }

    function handleSubmit(event) {
        event.preventDefault();
    }




    const displayResult = () => {
        let imei = serialNumber?.trim();
        if (props.result.display) {
            if (!props.result.isSuccess) {
                props.reportDWH({ actionType: 'WarrantyCheckAnswerPage', status: 'Error', messageText: 'General Error', IMEI: imei });
                
                return <p className='result bold-text alert'>
                    <Image src={require('./images/alert.svg')} alt='alert' />השירות לא פעיל זמנית</p>
            }
            if (!props.result.isCellcomEquipment) {
                props.reportDWH({ actionType: 'WarrantyCheckAnswerPage', status: 'Completed', messageText: 'No Data about Device', IMEI: imei });
                return <p className='result bold-text alert'>
                            <Image src={require('./images/alert.svg')} alt='alert' />
                            לא נמצא מכשיר תואם למספר שהוזן
                     </p>
            }
            switch (props.result.svcStatus) {
                case 'F':
                    props.reportDWH({ actionType: 'WarrantyCheckAnswerPage', status: 'Error', messageText: 'General Error', IMEI: imei });
                    return <p className='result bold-text alert'>
                        <Image src={require('./images/alert.svg')} alt='alert' />השירות לא פעיל זמנית
                    </p>
                case 'N':
                case 'W':
                    props.reportDWH({ actionType: 'WarrantyCheckAnswerPage', status: 'Completed', messageText: 'No Data about Device', IMEI: imei });
                    return <p className='result bold-text alert'>
                        <Image src={require('./images/alert.svg')} alt='alert' />לא נמצא מכשיר תואם למספר שהוזן
                    </p>
                case 'S':
                    if (props.result.warrantyStatus == 'Y') {
                        const endDate = moment(props.result.warrantyDate, "YYYYMMDD")?.format("DD/MM/YYYY");
                        props.reportDWH({ actionType: 'WarrantyCheckAnswerPage', status: 'Completed', messageText: 'Warranty Apply', IMEI: imei, date: endDate });
                        return <p className='result light'> <span className='text-wrapper'>
                            <Image src={require('./images/light.svg')} alt='light' />
                            אחריות היצרן של המכשיר שברשותכם הינה בתוקף עד לתאריך <span className='end-date'>{endDate}</span></span> </p>
                    }
                    else {
                        props.reportDWH({ actionType: 'WarrantyCheckAnswerPage', status: 'Completed', messageText: 'Warranty Not Apply', IMEI: imei });
                        return <p className='result bold-text light'>
                            <Image src={require('./images/light.svg')} alt='light' />
                            אחריות המכשיר הסתיימה
                        </p>
                    }
            }
        }
    }


    return (
        <form noValidate id={formId} onSubmit={handleSubmit}>
            <h1>בדיקת סטאטוס אחריות יצרן</h1>
            <h2>כאן ניתן לבדוק את תוקף אחריות היצרן על הציוד שברשותכם, אשר נקנה ב{window.Config.brand_Name_HE}</h2>
            <TextInput onChange={(e) => { onChangeInput(e.target.value) }} value={serialNumber} id="serialNumber" name="serialNumber" type="text" placeholder="מספר סידורי (IMEI)" error={validationError} />
            {props.result.display ? displayResult() : <p className='instructions'><Property context={props.context} iContent={props.iContent} field="description" /></p>}
            {props.result.display ?
                <p className='bottom-text'>לבדיקת תוקף אחריות היצרן של מכשיר נוסף <button className='clear-result-btn' onClick={() => { clearResultBtn() }}>לחצו כאן</button></p>
                :
                <BtnSubmit
                    formid={formId}
                    isBusiness={false}
                    isDisplayArrows={false}
                    text={'המשך'}
                    onclick={onClickBtn}
                />
            }
        </form>
    );
};

const mapStateToProps = (state) => {
    return {
        result: state.manufacturerWarrantyStatus.result,
    };
};

const mapDispatchToProps = { initBlock, resetBlock, clearResult, getWarrantyStatus, reportDWH };

export default connect(mapStateToProps, mapDispatchToProps)(ManufacturerWarrantyStatus);
